import { Flex, Text } from "@radix-ui/themes";
import { StopwatchIcon } from "@radix-ui/react-icons";
import { useTimer } from "@/hooks/useCountdown";
import { FC, JSX } from "react";

import SamsungHeader from "../../../shared/SamsungHeader";

const LeaderboardHeader: FC<{ endDate?: { seconds: number } }> = ({
  endDate,
}): JSX.Element => {
  const { timeObj, isTimeOver } = useTimer(endDate || undefined);
  const showTimer = !!endDate && !isTimeOver;

  // Drop the days segment unless it's actually counting days, so the chip reads
  // as a clean HH:MM:SS during the final day of a challenge.
  const display =
    timeObj.days !== "00"
      ? `${timeObj.days}:${timeObj.hours}:${timeObj.minutes}:${timeObj.seconds}`
      : `${timeObj.hours}:${timeObj.minutes}:${timeObj.seconds}`;

  return (
    <SamsungHeader
      lines={["FASTEST LAPS", "ON THE GRID"]}
      rightSlot={
        showTimer && (
          <Flex className="sr-timer-chip" align="center" gap="2" px="3" py="2">
            <StopwatchIcon width="20" height="20" />
            <Flex direction="column" align="start">
              <Text size="3" className="sr-timer-chip__label">
                CHALLENGE ENDS IN
              </Text>
              <Text size="7" weight="bold" className="sr-time">
                {display}
              </Text>
            </Flex>
          </Flex>
        )
      }
    />
  );
};

export default LeaderboardHeader;
